<template lang="pug">
  .layout
    y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px")
      v-card
        v-card-title.h6.basic800--text {{ $t('duplicate_form') }}

        v-card-text.pa-0
          v-card.pa-4
            v-form(ref="form")
              .field-name
                p.mb-2.label.basic600--text.text-uppercase {{ $t('form_name') }}
                v-text-field(v-model="formName" placeholder="Write form name here" background-color="basic200" height="40" outlined dense persistent-hint :rules="rules.not_empty" counter :maxlength="145")
        v-card-actions
          v-spacer
          v-btn(color='white', text @click='showModal = false')
            .button-Aa-small.primary400--text {{ $t('cancel') }}
          v-btn.mr-2(color='textColorAccent' depressed height=32 @click='clickSave' :loading="isLoading")
            .button-AA-small.basic100--text {{ $t('duplicate') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'DuplicateForm',
  props: ['open', 'parentForm'],
  components: {},
  data: () => ({
    formName: null,
    members: [],
    isLoading: false,
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required'],
    },
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    form: {
      get() {
        return this.parentForm
      },
      set(newValue) {
        this.$emit('update:parentForm', newValue)
      }
    },
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
  },
  watch: {
  },
  mounted () {
    this.formName = this.form.name
    this.$axios.get(`/forms/${this.form.id}/`)
      .then((response) => {
        this.members = response.data.members
      })
      .catch(() => {})
    // console.log(typeof (this.form.company))
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    clickSave () {
      this.isLoading = true
      let params = {
        company: typeof (this.form.company) === "object" ? this.form.company.id : this.form.company,
        email_enabled: this.form.email_enabled,
        email_required: this.form.email_required,
        extra_fields: this.form.extra_fields,
        language: this.form.language,
        layout: this.form.layout,
        members: this.members.map(m => m.id),
        name: this.formName,
        products: this.form.products.map(m => m.id),
        type: this.form.type,
        landing_field: this.form.landing_field
      }
      this.axios.post(`/forms/`, params)
        .then(resp => {
          this.showModal = false
          this.showMessage(['success', this.$t('success_message.form_duplicated')])
          this.$emit('duplicated', resp.data)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>
